module.exports = __webpack_public_path__ + "../resources/images/letsgo-letter-919ef5e4682cf5fb710f0832af0c096d.png";